
import React from 'react'
import FlexView from "react-flexview/lib"
import CloseIcon from '@material-ui/icons/Close';
import './CircledPopUpFrame.scss'
import { Container, Grid, IconButton } from '@material-ui/core'
import { Close } from '@material-ui/icons';

const CircledPopUpFrame = ({ closeDialog, ...props }) => {

    return (<>
        <FlexView vAlignContent={'center'} hAlignContent={'center'} column>
            {props.shouldHaveCircle && <FlexView hAlignContent={'center'} vAlignContent={'center'} className="circle_container">
                {props.circleHeader}
            </FlexView>}
            <FlexView column hAlignContent={'center'} className={!props.narrowContainer? "main_container" : "narrow_container"}>
                {props.includeCancelButton == true && <div onClick={closeDialog} className="close_btn_container"> <CloseIcon className="powderblue" fontSize="default" /> </div>}
                <div className="circled-popup-content">
                    <Container>
                        {props.children}
                    </Container>
                </div>
            </FlexView>
          </FlexView>
        </>
          )
}

export default CircledPopUpFrame;